import { Link, LinkProps } from '@vp/swan'
import { useIdentity } from '@vp/ubik-context'
import { useAnalytics } from '~/client/hooks/gallery/useAnalytics'
import { ANALYTICS_EVENT_ACTIONS } from '~/shared/constants'

type SignInButtonProps = Omit<LinkProps, 'ref'> & {
  signInText: string
  beforeSignIn?: () => void
}

export const SignInButton = (props: SignInButtonProps) => {
  const { signIn } = useIdentity()
  const { beforeSignIn, signInText, ...rest } = props
  const analytics = useAnalytics()

  const handleOnClick = async (): Promise<void> => {
    await beforeSignIn?.()
    signIn()

    analytics.trackEvent({
      action: ANALYTICS_EVENT_ACTIONS.BUTTON_CLICKED,
      eventLabel: 'Sign in button clicked',
      eventDetail: 'Sign in button clicked',
      ...analytics.getPageProperties(),
    })
  }

  return (
    <Link onClick={handleOnClick} {...rest}>
      {signInText}
    </Link>
  )
}
